import { createSelector } from "reselect"


const customerSupplierFollowingListStateSelector = (state) => state.customerSupplierFollowingList

const customerSupplierFollowingListSelector = createSelector(
  [customerSupplierFollowingListStateSelector],
  (supplierFollowingList) => supplierFollowingList.items
)


export const customerSupplierFollowingListAsNameAndId = createSelector(
  [customerSupplierFollowingListSelector], 
  (products) => (
    products.map(({_id,businessName}) => ({
      _id,
      businessName
    })
  ))
)



export const customerSupplierFollowingListLoadingSelector = createSelector(
  [customerSupplierFollowingListStateSelector],
  (supplierFollowingList) => supplierFollowingList.isLoading
);

export const customerSupplierFollowingListCountSelector = createSelector(
  [customerSupplierFollowingListStateSelector],
  (supplierFollowingList) => supplierFollowingList.count
);

export const searchValueSelector = createSelector(
  [customerSupplierFollowingListStateSelector] , 
  supplierFollowingList => supplierFollowingList.searchValue
)